// ** React Imports
import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const ClosuresAllindex    = lazy(() => import('../../views/closuresAll'))

const ClosuresAll = [
  {
    path: '/closuresAll',
    element: <ClosuresAllindex />
  }
]

export default ClosuresAll
